export const initialCheckoutValue = {
  number: '' as any,
  card_name: '',
  expiry_month: '' as any,
  expiry_year: '' as any,
  cvc: '' as any,
  country: '' as any,
  city: '' as any,
  state: '' as any,
  address_1: '' as any,
  address_2: '' as any,
  zip_code: '' as any,
};
